import React, { useState } from 'react';
import type { TeamVisual } from '../../cfbBranding/teamVisualResolver';
import TeamVisualChip from './TeamVisualChip';

export type TeamVisualBadgeProps = {
  visual: TeamVisual;
  size?: 'sm' | 'md';
  side?: 'away' | 'home';
  className?: string;
};

/**
 * Renders a team image only when `visual.badgeAssetUrl` is set.
 * `resolveTeamVisual` sets that URL only for a CFB school marked
 * `logo_status === 'licensed'`. Every other team draws the initials chip.
 */
const TeamVisualBadge: React.FC<TeamVisualBadgeProps> = ({
  visual,
  size = 'md',
  className = '',
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = Boolean(visual.badgeAssetUrl) && !imageFailed;

  if (showImage) {
    return (
      <img
        src={visual.badgeAssetUrl!}
        alt=""
        className={`${size === 'sm' ? 'h-8 w-8' : 'h-10 w-10'} object-contain ${className}`.trim()}
        data-testid="team-visual-badge-image"
        data-visual-kind={visual.kind}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <TeamVisualChip
      abbreviation={visual.initials}
      accentColor={visual.accentColor}
      size={size}
      className={className}
      testId="team-visual-badge-initials"
    />
  );
};

export default TeamVisualBadge;
